export default __webpack_public_path__ + "static/media/build-3.75478722.png";